export default {
  layout: {
    "rows": [
      {
        "fields": [ { "name": "statement.code" } ]
      },

      {
        "fields": [ { "name": "statement.statement" } ]
      }
    ]
  }
}
